import React from "react";

export type SegmentedControlOption<T extends string> = {
  value: T;
  label: string;
  testId?: string;
};

export default function SegmentedControl<T extends string>({
  value,
  options,
  onChange,
  ariaLabel,
}: {
  value: T;
  options: SegmentedControlOption<T>[];
  onChange: (value: T) => void;
  ariaLabel: string;
}) {
  return (
    <div
      className="inline-flex gap-1 rounded-lg border border-slate-300 bg-white p-0.5"
      role="group"
      aria-label={ariaLabel}
    >
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          className={`rounded-md px-3 py-1 text-xs font-semibold transition ${
            value === option.value
              ? "bg-snow-primary text-white"
              : "text-slate-600 hover:bg-slate-100"
          }`}
          onClick={() => onChange(option.value)}
          data-testid={option.testId ?? undefined}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
